import { FC } from 'react';
// component
import UsersComponent from 'components/main/Users';

const Users: FC = () => {
  return <UsersComponent />;
};

export default Users;
